document.addEventListener("DOMContentLoaded", () => {
  console.log("🚀 Navigation Script Loaded");
  
  // Get all relevant elements
  const navLinks = document.querySelectorAll(".nav-link");
  const sections = document.querySelectorAll(".shopify-section");
  
  // Console debugging info
  console.log(`Found ${navLinks.length} navigation links`);
  console.log(`Found ${sections.length} sections`);
  
  // Map each nav link to its target section
  const navMap = [];
  
  navLinks.forEach(link => {
    const targetId = link.getAttribute("href").substring(1); // Remove #
    
    // Try to find corresponding section using multiple methods
    let targetSection = null;
    
    // Method 1: Direct ID match
    targetSection = document.getElementById(targetId);
    
    // Method 2: Section with Shopify prefix
    if (!targetSection) {
      targetSection = document.getElementById(`shopify-section-${targetId}`);
    }
    
    // Method 3: Look for sections that contain the targetId in their ID
    if (!targetSection) {
      sections.forEach(section => {
        if (section.id.includes(targetId)) {
          targetSection = section;
        }
      });
    }
    
    // Store the mapping
    if (targetSection) {
      navMap.push({ 
        link: link, 
        section: targetSection, 
        targetId: targetId,
        rect: targetSection.getBoundingClientRect()
      });
      console.log(`✅ Mapped "${link.textContent.trim()}" to section with id "${targetSection.id}"`);
    } else {
      console.warn(`⚠️ Could not find section for "${link.textContent.trim()}" with target "${targetId}"`);
    }
  });
  
  // Function to determine which section is most visible
  function getMostVisibleSection() {
    const viewportHeight = window.innerHeight;
    const viewportMiddle = window.scrollY + (viewportHeight / 2);
    
    let bestSection = null;
    let bestVisibility = 0;
    
    navMap.forEach(item => {
      const rect = item.section.getBoundingClientRect();
      const sectionTop = window.scrollY + rect.top;
      const sectionBottom = sectionTop + rect.height;
      
      // Calculate how much of the section is in the viewport
      let visibleHeight = 0;
      
      if (viewportMiddle >= sectionTop && viewportMiddle <= sectionBottom) {
        // The middle of the viewport is inside this section
        visibleHeight = 1;
      } else {
        // Calculate overlap percentage
        const sectionHeight = rect.height;
        const sectionMiddle = sectionTop + (sectionHeight / 2);
        const distanceFromMiddle = Math.abs(viewportMiddle - sectionMiddle);
        const maxDistance = (viewportHeight / 2) + (sectionHeight / 2);
        
        visibleHeight = 1 - Math.min(1, distanceFromMiddle / maxDistance);
      }
      
      if (visibleHeight > bestVisibility) {
        bestVisibility = visibleHeight;
        bestSection = item;
      }
    });
    
    return bestSection;
  }
  
  // Function to update active link
  function updateActiveLink() {
    const activeItem = getMostVisibleSection();
    
    // First, remove active class from all links
    navLinks.forEach(link => {
      link.classList.remove("active");
    });
    
    // If we found an active section, highlight its link
    if (activeItem) {
      activeItem.link.classList.add("active");
      console.log(`🔍 Active section: ${activeItem.section.id} → "${activeItem.link.textContent.trim()}"`);
    }
  }
  
  // Add smooth scrolling
  navLinks.forEach(link => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      
      const matchingItem = navMap.find(item => item.link === link);
      
      if (matchingItem) {
        // Smooth scroll to the section
        matchingItem.section.scrollIntoView({ behavior: "smooth" });
        
        // Update active link (with slight delay to allow for scroll)
        setTimeout(() => {
          updateActiveLink();
        }, 100);
      }
    });
  });
  
  // Update active link on scroll (with debounce)
  let scrollTimeout;
  window.addEventListener("scroll", () => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    
    scrollTimeout = setTimeout(() => {
      updateActiveLink();
    }, 50);
  }, { passive: true });
  
  // Initial update
  updateActiveLink();
});